import paths from "routes/paths";

import { RouteType } from "types/routes";

// Menu Icon
import { ReactComponent as AdminIcon } from "vendor/menu_icon/admin.svg";
import { ReactComponent as Settings } from "vendor/menu_icon/settings.svg";
import { ReactComponent as InsuranceIcon } from "vendor/menu_icon/insurance-icon.svg";
import { ReactComponent as ReportMenuIcon } from "vendor/menu_icon/export-report.svg";
import { ReactComponent as Enrollment } from "vendor/menu_icon/enrollment.svg";
import { ReactComponent as InsuranceCompanyIcon } from "vendor/menu_icon/insurance-company-icon.svg";
import { ReactComponent as OccupationIcon } from "vendor/menu_icon/occupation-icon.svg";
import { ReactComponent as CustomerServiceIcon } from "vendor/menu_icon/customer-service-icon.svg";
import { ReactComponent as AppScreenDisplayIcon } from "vendor/menu_icon/app-screen-display-icon.svg";
import { ReactComponent as ReceiptIcon } from "vendor/menu_icon/receipt_icon.svg";
import { ReactComponent as SystemAndDataIcon } from "vendor/menu_icon/system-and-data-icon.svg";
import { ReactComponent as NotificationMenuIcon } from "vendor/menu_icon/notification-menu-icon.svg";
import { ReactComponent as RiderConfigIcon } from "vendor/menu_icon/rider-config-icon.svg";
import { ReactComponent as Broker } from "vendor/menu_icon/broker.svg";
import { ReactComponent as InsuranceManagementIcon } from "vendor/menu_icon/insurance-management-icon.svg";

import { AppColor } from "theme/app-color";
import { PERMISSIONS } from "constants/enums/permissions";

// Master workspace menu (for non-UUID tenants like "public")
export const MASTER_MENU: RouteType[] = [
  {
    id: "client.routes.menu.systemAndData",
    header: "client.routes.menu.menu",
    path: paths.workspacePath().toString(),
    icon: <SystemAndDataIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.workspace",
        path: paths.workspacePath().toString(),
        permissions: ["WORKSPACE_MANAGEMENT_READ"],
      },
    ],
  },
  {
    id: "client.routes.menu.adminManagement",
    path: paths.rolesPath().toString(),
    icon: <AdminIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.roleMenu",
        path: paths.rolesPath().toString(),
        permissions: ["PERMISSION_MANAGEMENT_READ"],
      },
      {
        id: "client.routes.menu.adminMenu",
        path: paths.adminsPath().toString(),
        permissions: ["ADMIN_MANAGEMENT_READ"],
      },
    ],
  },
];

export const TENANTED_MENU: RouteType[] = [
  {
    id: "client.routes.menu.customerService",
    header: "client.routes.menu.menu",
    path: paths.orderPath().toString(),
    icon: <CustomerServiceIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.order",
        path: paths.orderPath().toString(),
        permissions: [PERMISSIONS.ORDER_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.paymentTransaction",
        path: paths.paymentTransactionPath().toString(),
        permissions: [PERMISSIONS.PAYMENT_TRANSACTION_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.overdueTransaction",
        path: paths.overdueTransactionPath().toString(),
        permissions: [PERMISSIONS.OVERDUE_TRANSACTION_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.insuranceTransaction",
        path: paths.insuranceTransactionPath().toString(),
        permissions: [PERMISSIONS.INSURANCE_TRANSACTION_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.lead",
        path: paths.leadPath().toString(),
        permissions: [PERMISSIONS.LEAD_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.nameChangeRequest",
        path: paths.nameChangeRequestPath().toString(),
        permissions: [PERMISSIONS.NAME_CHANGE_TRANSACTION_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.user",
        path: paths.userPath().toString(),
        permissions: ["USER_MANAGEMENT_READ"],
      },
    ],
  },

  // {
  //   id: "client.routes.menu.riderConfig",
  //   path: paths.riderConfigPath().toString(),
  //   pathFunction: paths.riderConfigPath,
  //   icon: <RiderConfigIcon />,
  //   permissions: [],
  // },
  // {
  //   id: "client.routes.menu.report",
  //   path: paths.reportPath().toString(),
  //   pathFunction: paths.reportPath,
  //   icon: <ReportMenuIcon />,
  //   permissions: ["REPORT_MANAGEMENT_READ"],
  // },
  {
    id: "client.routes.menu.productManagement",
    path: paths.masterInsurancePlansPath().toString(),
    icon: <InsuranceManagementIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.insurancePlan",
        path: paths.masterInsurancePlansPath().toString(),
        permissions: [PERMISSIONS.MASTER_INSURANCE_PLAN_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.insurance",
        path: paths.insurancePath().toString(),
        permissions: ["INSURANCE_MANAGEMENT_READ"],
      },
      {
        id: "client.routes.menu.enrollment",
        path: paths.enrollmentPath().toString(),
        permissions: ["ENROLLMENT_MANAGEMENT_READ"],
      },
    ],
  },
  {
    id: "client.routes.menu.appScreenDisplay",
    path: paths.frontStoreManagementPath().toString(),
    icon: <AppScreenDisplayIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.frontStoreManagement",
        path: paths.frontStoreManagementPath().toString(),
        permissions: [PERMISSIONS.FRONT_STORE_MANAGEMENT_READ],
      },
    ],
  },
  {
    id: "client.routes.menu.notification",
    path: paths.notificationManagementPath().toString(),
    icon: <NotificationMenuIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.notificationManagement",
        path: paths.notificationManagementPath().toString(),
        permissions: [PERMISSIONS.NOTIFICATION_MANAGEMENT_READ],
      },
    ],
  },
  {
    id: "client.routes.menu.systemAndData",
    path: paths.brokerPath().toString(),
    icon: <SystemAndDataIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.broker",
        path: paths.brokerPath().toString(),
        permissions: [PERMISSIONS.BROKER_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.insuranceCompany",
        path: paths.insuranceCompanyPath().toString(),
        permissions: [PERMISSIONS.INSURANCE_COMPANY_MANAGEMENT_READ],
      },
      {
        id: "client.routes.menu.occupation",
        path: paths.occupationPath().toString(),
        permissions: ["OCCUPATION_MANAGEMENT_READ"],
      },
      // {
      //   id: "client.routes.menu.settingMenu",
      //   path: paths.settingsPath().toString(),
      //   permissions: [PERMISSIONS.SETTING_MANAGEMENT_READ],
      // },
    ],
  },
  {
    id: "client.routes.menu.adminManagement",
    path: paths.rolesPath().toString(),
    icon: <AdminIcon />,
    permissions: [],
    children: [
      {
        id: "client.routes.menu.roleMenu",
        path: paths.rolesPath().toString(),
        permissions: ["PERMISSION_MANAGEMENT_READ"],
      },
      {
        id: "client.routes.menu.adminMenu",
        path: paths.adminsPath().toString(),
        permissions: ["ADMIN_MANAGEMENT_READ"],
      },
    ],
  },
];

export const MAIN_MENU = TENANTED_MENU;
